import Filters from "./Filters/Filters.jsx";
import Product from "./Product/Product.jsx";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNewProducts } from "../../../redux/newProductActions.js";
import style from "./NewsCatalogue.module.css";

const NewsCatalogue = () => {

    const dispatch = useDispatch();
    const newProductsCopy = useSelector(state => state.newProducts.newProductsCopy);

    useEffect(() => {
        dispatch(getNewProducts());
    }, [dispatch]);

    //----- PAGINADO
    
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const [paginatedProducts, setPaginatedProducts] = useState([]);

    useEffect(() => {
        if (Array.isArray(newProductsCopy)) {
            const newPageData = newProductsCopy.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
            );

            setPaginatedProducts((prev) => {
                const prevStringified = JSON.stringify(prev);
                const newStringified = JSON.stringify(newPageData);

                return prevStringified === newStringified ? prev : newPageData;
            });
        }
    }, [newProductsCopy, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(newProductsCopy.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const getPageButtons = () => {
        const buttons = [];
        let startPage, endPage;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`pageButton ${currentPage === i ? 'currentPage' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };

    return(
        <div className={style.div}>
            <h2>Productos <span>destacados</span></h2>
            <h4>Novedades en tecnología eléctrica</h4>
            <Filters/>
            <div className="paginationContainer">
                <div className="pagination">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        ◂
                    </button>
                    {getPageButtons()}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        ▸
                    </button>
                </div>
            </div>
            <div className={style.cards}>
                {paginatedProducts.map(newProduct => (
                    <div className={style.card}>
                        <Product
                            key={newProduct.id}
                            id={newProduct.id}
                            brand={newProduct.brand}
                            category={newProduct.category}
                            image={newProduct.image}
                            description={newProduct.description}
                        />
                    </div>
                ))}
            </div>
            <div className="paginationContainer">
                <div className="pagination">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        ◂
                    </button>
                    {getPageButtons()}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        ▸
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewsCatalogue;